import { render } from "./SoftField.vue?vue&type=template&id=4a612c2e&scoped=true"
import script from "./SoftField.vue?vue&type=script&lang=js"
export * from "./SoftField.vue?vue&type=script&lang=js"

import "./SoftField.vue?vue&type=style&index=0&id=4a612c2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a612c2e"]])

export default __exports__